<template>
    <page-title :title="t('inquiry.successfullyCreatedTitle')" />

    <v-breadcrumbs :items="breadcrumbs">
        <template #item="{ item }">
            <v-breadcrumbs-item :to="item.to" exact :disabled="item.disabled" class="text-primary">
                {{ item.title }}
            </v-breadcrumbs-item>
        </template>
    </v-breadcrumbs>

    <card-skeleton>
        <card-title
            v-show="route.params.id"
            id="success-case-number"
            icon="mdi-check-circle"
            color="success"
            :text="t('inquiry.successfullyCreatedCaseNumber') + ': ' + route.params.id"
        >
        </card-title>

        <v-card-text class="text-body-1">
            {{ t('inquiry.successfullyCreatedBottomText') }}
        </v-card-text>
    </card-skeleton>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';
import { routeNames } from '@/router';
import { useI18n } from 'vue-i18n';
import { PageTitle } from '@/features/common/components/page';
import CardTitle from '@/features/common/components/CardTitle.vue';
import CardSkeleton from '@/features/common/components/CardSkeleton.vue';

const route = useRoute();
const { t } = useI18n();

const breadcrumbs = [
    { title: t('inquiry.contactForm'), to: { name: routeNames.issueSubmit } },
    { title: t('inquiry.successfullyCreatedTitle'), to: '', disabled: true }
];
</script>
